import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import {
  getFileExtension,
  getM3uFileValidationMessage,
  isAllowedM3uFile,
  M3U_FILE_ACCEPT
} from '../../helpers/m3uFiles'
import { toast } from 'react-toastify'
import { Button, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import { useCreateM3uFileMutation } from '../../redux/apis/linkManagement/m3u/lmM3uFilesApiSlice'

const EditCreateM3uFile = ({ state, open, setOpen, record }) => {
  const [files, setFiles] = useState([])

  const [
    create,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateM3uFileMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      last_updated_by: getUserId()
    },
    onSubmit: async values => {
      if (!files.length) {
        toast.error('Please select at least one file.')
        return
      }

      const invalidFiles = files.filter(file => !isAllowedM3uFile(file))
      if (invalidFiles.length) {
        toast.error(getM3uFileValidationMessage())
        return
      }

      const formData = new FormData()
      formData.append('last_updated_by', values.last_updated_by)

      files.forEach(file => {
        formData.append('file_path', file) // backend should accept array of file_path
      })

      files.forEach(file => {
        formData.append('file_type', getFileExtension(file.name))
      })

      console.log('FormData entries:', [...formData.entries()])

      try {
        await create(formData).unwrap()
      } catch (err) {
        console.error('Create error', err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd])

  useEffect(() => {
    if (SuccessAdd && state === 'create') {
      toast.success('M3U File(s) created successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd])

  useEffect(() => {
    if (!open) setFiles([])
  }, [open])

  const handleFileChange = e => {
    const selected = Array.from(e.target.files || [])
    const valid = selected.filter(isAllowedM3uFile)
    const invalid = selected.filter(file => !isAllowedM3uFile(file))

    if (invalid.length) {
      toast.error(getM3uFileValidationMessage(invalid))
    }

    setFiles(valid)
    e.target.value = ''
  }

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? 'Edit M3U File' : 'Create M3U File'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).forEach(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding} />
      <div className='mb-3'>
        <label>File Path</label>
        <div className='flex gap-4'>
          <input
            type='file'
            multiple
            onChange={handleFileChange}
            accept={M3U_FILE_ACCEPT}
          />
        </div>
        {files.length > 0 && (
          <ul className='mt-2 text-sm text-gray-600'>
            {files.map(file => (
              <li key={file.name}>• {file.name}</li>
            ))}
          </ul>
        )}
      </div>
    </Modal>
  )
}

export default EditCreateM3uFile
